import { useState, useEffect } from 'react';
import StrokeTitle from '../components/ui/StrokeTitle';
import { useInView } from 'react-intersection-observer';
import Button from '../components/ui/Button';
import { Link } from 'react-router-dom';
import ReactPlayer from 'react-player';
import '../styles/pages/top.scss';
import Modal from '../components/ui/Modal';
import FlowerTitle from '../components/ui/FlowerTitle';

const Top = () => {

  const [logo, logoLoaded] = useState(false);
  const [keyart, keyLoaded] = useState(false);

  const [ref2, inView2] = useInView({
    threshold: 1,
    triggerOnce: true
  });


  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      logoLoaded(true);
    };
    img.src = `${process.env.PUBLIC_URL}/img/logo.png`;

    const img2 = new Image();
    img2.onload = () => {
      keyLoaded(true);
    };
    img2.src = `${process.env.PUBLIC_URL}/img/mobile-header.webp`;
  }, []);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    
    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 4
  })

  const [dlcModal, setDLCModal] = useState({
    visible: false,
    current: 0,
    size: 1
  })

    const [endModal, setEndModal] = useState({
    visible: false,
    current: 0,
    size: 4
  })

  return (
    <div className="page-container">
      <Modal modal={modal} setModal={setModal} url="top_ss.jpg"/>
      <Modal modal={dlcModal} setModal={setDLCModal} url="dlc-comp.png"/>
      <Modal modal={endModal} setModal={setEndModal} url="top/additional_content_ss_0.jpg"/>
      <header className="header-wrapper">
        <div className={`screen-left ${logo && keyart && "left-open"}`}/>
        <div className={`screen-right ${logo && keyart && "right-open"}`}/>
        <section className="header-contents">
          <img src={`${process.env.PUBLIC_URL}/img/logo.png`} alt="Disgaea 7 Logo" />
          <div className="video-container"
            style={{
              maxWidth: '400px'
            }}
          >
            <div className="video-wrapper">
              <ReactPlayer url="https://youtu.be/cGPX50LN0EI"/>
            </div>
          </div>
          {
            windowWidth > 1200 &&
            <img src={`${process.env.PUBLIC_URL}/img/captcha.webp`} alt="Bushido is back, baby" className="captcha" />
          }
          <h1 className='header-date gradient-text'>À paraître le 10 octobre 2025</h1>
        </section>
      </header>
      {
        windowWidth < 1400 &&
        <img src={`${process.env.PUBLIC_URL}/img/captcha.webp`} alt="Bushido is back, baby" className="captcha" />
      }
      <div className="video-container mobile-video"
        style={{
          maxWidth: '90vw'
        }}
      >
      <div className="video-wrapper">
        <ReactPlayer url="https://youtu.be/cGPX50LN0EI"/>
      </div>
    </div>
      <StrokeTitle text="Disgaea 7 prend des proportions encore plus importantes ! "/>
      <div className="pair">
        <div className="accent-wrapper">
          <h3 className="accent-tl black-yellow-text">L'équipe des Démons sans Frontières se rend dans des Sous-Mondes du passé !</h3>
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/top/additional_content_ss_01.jpg`} alt="Top-SS" onClick={()=>{
            setEndModal(
              {
                ...endModal,
                'visible': true,
                'current': 1,
              }
            )
          }}/>
        </div>
        <div className="accent-wrapper">
          <h3 className="accent-br black-yellow-text">Asagi rejoint le combat !</h3>
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/top/additional_content_ss_02.jpg`} alt="Top-SS" onClick={()=>{
            setEndModal(
              {
                ...endModal,
                'visible': true,
                'current': 2,
              }
            )
          }}/>
        </div>
      </div>
      <div className="pair">
        <div className="accent-wrapper">
          <h3 className="accent-tr black-yellow-text">Des stats allant jusqu'à <br/> 999 999 999 ?!
</h3>
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/top/additional_content_ss_03.jpg`} alt="Top-SS" onClick={()=>{
            setEndModal(
              {
                ...endModal,
                'visible': true,
                'current': 3,
              }
            )
          }}/>
        </div>
        <div className="accent-wrapper">
          <h3 className="accent-bl black-yellow-text">Affrontez Rakshasa Baal, le véritable boss ultime !
</h3>
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/top/additional_content_ss_04.jpg`} alt="Top-SS" onClick={()=>{
            setEndModal(
              {
                ...endModal,
                'visible': true,
                'current': 4,
              }
            )
          }}/>
        </div>
      </div>
      <p className={`short-desc white-text ${inView2 && "fadeIn"}`} ref={ref2}>
       Découvrez toutes les nouveautés de Disgaea 7 Complete en cliquant sur le gros bouton orange ci-dessous ! 
      </p>
      <Link to="../whats-new#additional_content">
        <Button text="Les nouveautés" color="red"/>
      </Link>

      
      <StrokeTitle text="Contient tous les DLC de Disgaea 7 !"/>
      <img 
        style={{maxWidth: '850px', marginBottom: '25px'}}
        className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/dlc-comp-fr.png`} alt="Tous les personnages et les histoires des DLC précédents sont inclus !" 
        onClick={()=>{
            setDLCModal(
            {
                ...dlcModal,
                'visible': true,
                'current': 1,
            }``
            )
      }}/>
      <Link to="../whats-new#dlc">
        <Button text="Infos sur les DLC" color="red"/>
      </Link>

      <p className={`short-desc white-text ${inView2 && "fadeIn"}`} ref={ref2}>
        Rejoignez Fuji et Pirilika dans leur périlleuse aventure, marquée sous le signe de la rédemption, et découvrez de nouvelles mécaniques pour la première fois dans la série !
      </p>
      <div className="top-ss">
        <img className="ss" src={`${process.env.PUBLIC_URL}/img/ss/top_ss1.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 1,
            }
          )
        }}/>
        <img className="ss" src={`${process.env.PUBLIC_URL}/img/ss/top_ss2.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 2,
            }
          )
        }}/>
        <img className="ss" src={`${process.env.PUBLIC_URL}/img/ss/top_ss3.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 3,
            }
          )
        }}/>
        <img className="ss" src={`${process.env.PUBLIC_URL}/img/ss/top_ss4.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 4,
            }
          )
        }}/>
      </div>
      <FlowerTitle text="Personnages"/>
      <div className="top-character-list">
        <div className="top-character-wrapper">
          <Link to='/characters#higan'>
            <Button text="Higan Zesshosai" color="higan"/>
          </Link>
          <img src={`${process.env.PUBLIC_URL}/img/characters/img_main_07.png`} alt="" />
        </div>
        <div className="top-character-wrapper">
          <Link to='/characters#ceefore'>
            <Button text="Cyphore" color="ceefore"/>
          </Link>          
          <img src={`${process.env.PUBLIC_URL}/img/characters/img_main_05.png`} alt="" />
        </div>
        <div className="top-character-wrapper">
          <Link to='/characters#ao'>
            <Button text="Ao" color="ao"/>
          </Link>          
          <img src={`${process.env.PUBLIC_URL}/img/characters/img_main_03.png`} alt="" />
        </div>
        <div className="top-character-wrapper" style={{marginLeft: '25px'}}>
          <Link to='/characters#fuji'>
            <Button text="Fuji" color="fuji"/>
          </Link>          
          <img src={`${process.env.PUBLIC_URL}/img/characters/img_main_01.png`} alt="" />
        </div>
        <div className="top-character-wrapper"  style={{marginRight: '25px'}}>
          <Link to='/characters#pirilika'>
            <Button text="Pirilika" color="pirilika"/>
          </Link>          
          <img src={`${process.env.PUBLIC_URL}/img/characters/img_main_02.png`} alt="" />
        </div>
        <div className="top-character-wrapper">
          <Link to='/characters#suisen'>
            <Button text="Suisen" color="suisen"/>
          </Link>
          <img src={`${process.env.PUBLIC_URL}/img/characters/img_main_06.png`} alt="" />
        </div>
        <div className="top-character-wrapper">
          <Link to='/characters#yeyasu'>
            <Button text="Oyéyasu" color="yeyasu"/>
          </Link>
          <img src={`${process.env.PUBLIC_URL}/img/characters/img_main_04.png`} alt="" />
        </div>
      </div>
      <Spec/>
    </div>
  )
}

const Spec = () => (
  <>
    <FlowerTitle text="Infos produit"/>
    <div className="table-wrapper">
      <table>
       <tbody>
          <tr>
            <th className='yellow-text'>Titre :</th>
            <td className='white-text'>Disgaea 7 Complet</td>
          </tr>
          <tr>
            <th className='yellow-text'>Sortie :</th>
            <td className='white-text'>10 octobre 2025</td>
          </tr>
          <tr>
            <th className='yellow-text'>Plateforme :</th>
            <td className='white-text'> Nintendo Switch™2</td>
          </tr>
          <tr>
            <th className='yellow-text'>Genre :</th>
            <td className='white-text'>RPG Tactique</td>
          </tr>
          <tr>
            <th className='yellow-text'>Joueur(s) :</th>
            <td className='white-text'>1</td>
          </tr>
          <tr>
            <th className='yellow-text'>Textes :</th>
            <td className='white-text'>Français, Anglais</td>
          </tr>
          <tr>
            <th className='yellow-text'>Voix :</th>
            <td className='white-text'>Anglais, Japonais</td>
          </tr>
        </tbody>
      </table>
    </div>
  </>
)

export default Top;